import React from 'react';
import { ClickAwayListener } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PreventiveMaintenanceComment } from '../../../interfaces/customer-api';
import Close from '../../assets/close.svg';
import css from './PMCommentsModal.module.scss';

interface PMCommentsModalProps {
    isOpen: boolean;
    onClose: () => void;
    comments: PreventiveMaintenanceComment[];
}

export const PMCommentsModal: React.FC<PMCommentsModalProps> = ({ isOpen, onClose, comments }) => {
    const { t } = useTranslation('MyEquipmentItem');

    if (!isOpen) return null;

    return (
        <div className={css.darkBackground}>
            <ClickAwayListener onClickAway={onClose}>
                <div className={css.modal} data-cy="pm-comments-modal">
                    <div className={css.modalHeader}>
                        <span className={css.modalTitle} data-cy="pm-modal-title">{t('Comments')}</span>
                        <Close className={css.closeButton} onClick={onClose} aria-label={t('Close')} data-cy="pm-close-btn" />
                    </div>
                    <div className={css.modalBody}>
                        {comments.length === 0 ? (
                            <p className={css.noData} data-cy="pm-modal-empty">{t('No comments')}</p>
                        ) : (
                            <table className={css.table} data-cy="pm-modal-table">
                                <thead>
                                    <tr>
                                        <th>{t('Chapter')}</th>
                                        <th>{t('Checkpoint')}</th>
                                        <th>{t('Comment')}</th>
                                        <th>{t('Status')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {comments.map((c, i) => (
                                        <tr key={i}>
                                            <td>{c.operation}</td>
                                            <td>{c.checkpoint}</td>
                                            <td>{c.comment}</td>
                                            {/* TODO: check other status */}
                                            <td className={c.status === 'NOT_OK' ? css.statusNotOk : css.statusOk}>{c.status}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </ClickAwayListener>
        </div>
    );
};
